<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:new="newHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>

import WorkflowForm from "../../../components/personnel/workflowlisting/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": WorkflowForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setupapprvlworkflow.editapprvlworkflow'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadWorkflowHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/workflow/edit/" + this.id})
        .then(res => {
          vm.formData = res.data.rec[0];

          vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.pageTitleValue = res.data.rec[0].wftypedesc;
          vm.formData.userid = this.$store.getters.userId;
          vm.formData.detailid = res.data.rec[0].detailid;
          vm.formData.wftypeid = res.data.rec[0].wftypeid;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadWorkflowDetailHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/workflowd/edit/" + this.id})
        .then((res) => {
          vm.formData.workflowdetails = res.data.rec;
        //  vm.autoapr = res.data.rec.workflowdetails.autoapr == "Y" ? true : false;

               for (let i = 0; i < vm.formData.workflowdetails.length; i++) {
                 Object.assign(vm.formData.workflowdetails[i], { action: 2, });
            }


            //  for (var i = 0; i < res.data.rec.workflowdetails.length; i++){
            //    let detailsitem = {
            //      index: i,
            //      compnyid: res.data.rec.workflowdetails[i].compnyid,
            //      levelno: res.data.rec.workflowdetails[i].levelno,
            //      autoapr: res.data.rec.workflowdetails[i].autoapr,
            //      email: res.data.rec.workflowdetails[i].email,
            //      IsEmail: res.data.rec.workflowdetails[i].IsEmail == "Y" ? true : false,
            //      hronly: res.data.rec.workflowdetails[i].hronly,
            //      hrlast: res.data.rec.workflowdetails[i].hrlast,
            //      remindone: res.data.rec.workflowdetails[i].remindone,
            //      remindnext: res.data.rec.workflowdetails[i].remindnext,
            //      action: 1,
            //      stamp: res.data.rec.workflowdetails[i].stamp,
            //      userid: this.$store.getters.userId,


            //   };
            //    vm.formData.workflowdetails.push(detailsitem);
            //  }
         
          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/workflow/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workflowlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "workflowlist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/workflow/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workflowlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    newHandler() {
      this.$router.push({ name: "workflownew" });
    },
  },

  async mounted() {
    await this.loadWorkflowHandler();
    await this.loadWorkflowDetailHandler();
  },
};
</script>